<app-header></app-header>
<app-sidebar></app-sidebar>
<div class="content-wrapper pt-4 pb-4">
    <app-dashboard-advogado></app-dashboard-advogado>
</div>
